import { httpDelete, httpGet, httpPatch, httpPost } from "../connection";

export async function getEvidenceTypes(values = { id: null }) {
  if (values.id == null) return await httpGet(`/evidence-types`);
  else return await httpGet(`/evidence-types/${values.id}`);
}

export async function createEvidenceType(values: { evi_type: string }) {
  return await httpPost(`/evidence-types`, values);
}

export async function updateEvidenceType(
  evidence_type_id: number,
  values = {}
) {
  return await httpPatch(`/evidence-types/${evidence_type_id}`, values);
}

export async function deleteEvidenceType(
  id: number,
  options = { replace: null }
) {
  if (options.replace == null) return await httpDelete(`/evidence-types/${id}`);
  else if (options.replace != null)
    return await httpDelete(`/evidence-types/${id}?replace=${options.replace}`);
}

const EvidenceTypesApi = {
  getEvidenceTypes,
  createEvidenceType,
  updateEvidenceType,
  deleteEvidenceType,
};

export default EvidenceTypesApi;
